/*
 * Session reset registry (spec 069 UF-4/UF-20). Feature stores keep module-level
 * state (run lists, form drafts, caches). Each store registers its reset here
 * once, at module load; `resetSession()` runs every registered reset when the
 * signed-in user changes (login, logout, rejected key). Tests call the same
 * `resetSession()` production uses, so there are no test-only reset exports.
 */
const resets = new Set<() => void>()

/** Registers a reset. Returns the function unchanged so a store can export it as before. */
export function registerSessionReset<T extends () => void>(reset: T): T {
  resets.add(reset)
  return reset
}

/** Runs every registered reset. One failing reset never stops the others. */
export function resetSession(): void {
  for (const reset of [...resets]) {
    try {
      reset()
    } catch (error) {
      console.error('session reset failed', error)
    }
  }
}
